export default {"src":"/_next/static/image/public/images/ic_otp_locked.6d94bf2aeb612348fda5882938da87c6.svg","height":170,"width":122};